import Breakpoint from '../helpers/breakpoint';

/**
 * Module description...
 *
 * @returns {{init: init}}
 */
const MainNav = (() => {
  const DOM = {};
  const transitionBreakpoint = "xl";
  let button;

  const cacheDOM = () => {
    DOM.hamburger = document.getElementsByClassName("js-toggleMenu");
    DOM.toggleNav = document.getElementsByClassName("js-navigation");
  };

  const toggleNav = (button) => {
    Array.from(DOM.toggleNav).forEach((menu) => {
      if (menu.getAttribute('data-menu') === button) {
        if (menu.classList.contains("open")) {
          menu.classList.remove("open");
          DOM.hamburger[0].innerHTML = "Menu";
        } else {
          menu.classList.add("open");
          DOM.hamburger[0].innerHTML = "Close";
        }
      }
    });
  };

  const buttonClicked = (e) => {
    button = e.target.dataset.dropdown;

    if (typeof button == "undefined") {
      button = e.target.parentElement.dataset.dropdown;
    }
    toggleNav(button);
  };


  const eventListeners = () => {
    let addMobileNavEventListeners = () => {
      Array.from(DOM.hamburger).forEach((menu) => {
        menu.addEventListener("click", buttonClicked);
      });
    }

    if (Breakpoint.isBreakpointDown(transitionBreakpoint)) {
      addMobileNavEventListeners();
    }

    window.addEventListener('resize', function () {
      if (Breakpoint.isBreakpointDown(transitionBreakpoint)) {
        addMobileNavEventListeners();
      }
    }, false);
  };

  const init = () => {
    cacheDOM();
    eventListeners();
  };

  return {
    init,
  };
})();

export default MainNav;
